// src/pages/Marketing/components/MarketingLanguageSwitcher.js
//
// A small pill toggle in the top nav — every active PlatformLanguage
// (getPublicMarketingLanguages) is a button; the active one is highlighted.
// Deliberately not a <select> — with English/Arabic as the day-one set this
// reads faster at a glance, and it still scales fine if a third or fourth
// language is added later (see PlatformLanguages.js, this feature's own
// plan doc).
import { useMarketingI18n } from "../MarketingI18nContext";

export default function MarketingLanguageSwitcher() {
  const { languages, languageCode, switchLanguage } = useMarketingI18n();
  if (languages.length < 2) return null;

  return (
    <div className="mkt-lang-switcher" role="group" aria-label="Language">
      {languages.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`mkt-lang-pill${l.code === languageCode ? " active" : ""}`}
          onClick={() => switchLanguage(l.code)}
        >
          {l.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
